<full-dialog color="primary">
  <!--|DIALOG HEADER|-->
  <div dialog-header>
    <div fxLayout="row" style="height: 30px" fxLayoutAlign="space-between center">
      <p>
        <img [src]="getHeaderImage()" />
        <strong class="headerTitle">{{ modalInfo.HeaderTitle }}</strong>
      </p>
      <button
        *ngIf="modalInfo.isCloseButtonVisible()"
        (click)="close()"
        type="button"
        class="close-modal font-color-white"
        data-dismiss="modal"
        aria-label="Fechar"
        style="border: 0">
        <span aria-hidden="true" style="opacity: 1">&times;</span>
      </button>
    </div>
  </div>

  <!--|DIALOG CONTENT|-->
  <div dialog-content>
    <alert id="alert-modal" style="max-width: 800px"></alert>
    <mat-grid-list rowHeight="80px" gutterSize="2px" *ngIf="shouldGridListBeVisible()" cols="{{ getNumberOfColumns() }}">
      <div *ngFor="let content of modalInfo.Content">
        <mat-grid-tile *ngIf="content.value === 'blank'"></mat-grid-tile>

        <mat-grid-tile *ngIf="content.value !== 'blank' && !content.isSearchableTextArea() && content.getVisibility()" class="title-item" hidden="true">
          <!--|TEXT INPUT|-->
          <mat-form-field
            class="inputText"
            style="width: 90%"
            *ngIf="
              content.isInputText() && !content.hasTextMask() && !content.isSlaveInput() && !content.isSearchableTextArea() && modalInfo.Content.length > 1
            ">
            <input
              matInput
              id="{{ content.propertyName }}"
              type="{{ content.getTypeAsString() }}"
              placeholder="{{ content.placeHolder }}"
              value="{{ content.value }}"
              [(ngModel)]="content.value"
              [ngModelOptions]="{ standalone: true }"
              [required]="content.required"
              [disabled]="content.isInputDisabled()"
              (change)="onDataChange()" />
          </mat-form-field>

          <!--|TEXT INPUT WITH MASK|-->
          <mat-form-field
            class="inputText"
            style="width: 90%"
            *ngIf="
              content.isInputText() && content.hasTextMask() && !content.isSlaveInput() && !content.isSearchableTextArea() && modalInfo.Content.length > 1
            ">
            <input
              matInput
              id="{{ content.propertyName }}"
              type="{{ content.getTypeAsString() }}"
              placeholder="{{ content.placeHolder }}"
              value="{{ content.value }}"
              [(ngModel)]="content.value"
              [ngModelOptions]="{ standalone: true }"
              [required]="content.required"
              [disabled]="content.isInputDisabled()"
              [textMask]="{ mask: content.getTextMask(), guide: false, keepCharPositions: true }"
              (change)="onDataChange()" />
          </mat-form-field>

          <!--|SLAVE TEXT INPUT|-->
          <mat-form-field
            class="inputText"
            style="width: 90%"
            *ngIf="
              hasMasterPermition() &&
              content.isInputText() &&
              !content.hasTextMask() &&
              content.isSlaveInput() &&
              !content.isSearchableTextArea() &&
              modalInfo.Content.length > 1
            ">
            <input
              matInput
              id="{{ content.propertyName }}"
              type="{{ content.getTypeAsString() }}"
              placeholder="{{ content.getPlaceHolder() }}"
              value="{{ content.value }}"
              [(ngModel)]="content.value"
              [ngModelOptions]="{ standalone: true }"
              [required]="content.required"
              (change)="onDataChange()" />
          </mat-form-field>

          <!--|SLAVE TEXT INPUT WITH MASK|-->
          <mat-form-field
            class="inputText"
            style="width: 90%"
            *ngIf="
              hasMasterPermition() &&
              content.isInputText() &&
              content.hasTextMask() &&
              content.isSlaveInput() &&
              !content.isSearchableTextArea() &&
              modalInfo.Content.length > 1
            ">
            <input
              matInput
              id="{{ content.propertyName }}"
              type="{{ content.getTypeAsString() }}"
              placeholder="{{ content.getPlaceHolder() }}"
              value="{{ content.value }}"
              [(ngModel)]="content.value"
              [ngModelOptions]="{ standalone: true }"
              [required]="content.required"
              [textMask]="{ mask: content.getTextMask(), guide: false, keepCharPositions: true }"
              [minlength]="content.minLength"
              (change)="onDataChange()" />
          </mat-form-field>

          <mat-form-field
            style="width: 80%"
            *ngIf="content.isInputText() && !content.isSearchableTextArea() && !content.isInputDisabled() && modalInfo.Content.length == 1">
            <input
              matInput
              id="{{ content.propertyName }}"
              type="{{ content.getTypeAsString() }}"
              placeholder="{{ content.placeHolder }}"
              value="{{ content.value }}"
              [(ngModel)]="content.value"
              [ngModelOptions]="{ standalone: true }"
              [required]="content.required"
              [disabled]="content.isInputDisabled()"
              (change)="onDataChange()" />
          </mat-form-field>

          <!--|TEXTAREA INPUT|-->
          <mat-form-field
            class="inputTextarea"
            style="width: 90%"
            *ngIf="content.isInputTextArea() && !content.isSearchableTextArea() && modalInfo.Content.length > 1">
            <textarea
              matInput
              id="{{ content.propertyName }}"
              type="{{ content.getTypeAsString() }}"
              placeholder="{{ content.placeHolder }}"
              value="{{ content.value }}"
              [(ngModel)]="content.value"
              [ngModelOptions]="{ standalone: true }"
              [required]="content.required"
              [disabled]="content.isInputDisabled()"
              (change)="onDataChange()"></textarea>
          </mat-form-field>

          <!--|COMBOBOX INPUT|-->
          <mat-form-field *ngIf="content.isInputComboBox()" style="width: 90%">
            <mat-label>{{ content.getPlaceHolder() }}</mat-label>
            <mat-select [value]="content.value" (selectionChange)="onSelectChange(content, $event)">
              <mat-option *ngFor="let option of content.options" [value]="option.value">{{ option.value }}</mat-option>
            </mat-select>
          </mat-form-field>

          <!--|CHECKBOX INPUT|-->
          <mat-checkbox
            class="inputText"
            style="width: 90%"
            *ngIf="content.isInputChechbox() && !content.isMasterInput() && !content.isSearchableTextArea() && modalInfo.Content.length > 1"
            id="{{ content.getName() }}"
            [(ngModel)]="content.value"
            [ngModelOptions]="{ standalone: true }"
            [required]="content.required"
            [disabled]="content.isInputDisabled()"
            [labelPosition]="content.getLabelPosition()"
            (change)="onDataChange()"
            >{{ content.placeHolder }}</mat-checkbox
          >

          <!--|MASTER CHECKBOX INPUT|-->
          <mat-checkbox
            class="inputText"
            style="width: 90%"
            *ngIf="content.isInputChechbox() && content.isMasterInput() && !content.isSearchableTextArea() && modalInfo.Content.length > 1"
            id="master-input"
            [(ngModel)]="content.value"
            [ngModelOptions]="{ standalone: true }"
            [required]="content.required"
            [disabled]="content.isInputDisabled()"
            [labelPosition]="content.getLabelPosition()"
            #masterInput
            (click)="scrollToBottom()"
            (change)="onDataChange()"
            >{{ content.placeHolder }}</mat-checkbox
          >
        </mat-grid-tile>
      </div>
    </mat-grid-list>

    <div *ngFor="let content of modalInfo.Content">
      <div class="searchableTextContentArea" *ngIf="content.isSearchableTextArea()">
        <div class="textAreaHeader">
          <label for="inputAddress" style="color: rgb(135, 135, 135)" class="font-size-20" *ngIf="content.displayName && content.isSearchableTextArea()">{{
            content.displayName
          }}</label>
          <div class="textAreaInput">
            <div *ngIf="content.isSearchableTextArea() && isSearchTextVisibleOnFocus(content)" class="search-input">
              <span>(Para navegar utilize a tecla ENTER)</span>
              <input placeholder="Pesquisar" (keyup)="onSearch($event)" #searchInput type="text" id="txtSearch" />
            </div>
            <a *ngIf="content.searchable && !isSearchTextVisible(content)">
              <img alt="busca" (click)="setSearchTextVisible(content)" src="./assets/icons/icon_search.svg" />
            </a>
            <a *ngIf="content.searchable && isSearchTextVisible(content)">
              <img alt="fechar" (click)="setSearchTextVisible(content)" src="./assets/icons/close_search.svg" />
            </a>
          </div>
        </div>
        <textarea
          *ngIf="content.isInputTextArea()"
          id="{{ content.propertyName }}"
          placeholder="{{ content.placeHolder }}"
          value="{{ content.value }}"
          [(ngModel)]="content.value"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="content.isInputDisabled()"
          rows="10">
        </textarea>
        <div>
          <div [innerHTML]="highlight(content) | keepHtml" #textArea *ngIf="content.isSearchableTextArea()" class="searchableTextArea" contenteditable="false">
            {{ getTextAreaInnerHTML() }}
          </div>
        </div>
        <div *ngIf="content.isSearchableTextArea()" class="textAreaBottom" id="clipBoardDiv">
          <a style="cursor: pointer; color: dodgerblue; font-size: 10px" (click)="copyToClipBoard(content)">Copy to clipboard</a>
          <label *ngIf="isTextCopied()" style="font-size: 10px; color: darkgreen" class="padding-left-10">Copied</label>
        </div>
      </div>
    </div>
    <div id="bottom"></div>
  </div>

  <!--|DIALOG ACTIONS|-->
  <div dialog-actions>
    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" fxFlex>
      <div style="padding-left: 10px; padding-right: 10px">
        <button *ngIf="modalInfo.isCloseButtonVisible()" type="button" mat-button style="float: right" (click)="close()">Fechar</button>
      </div>
      <div>
        <button
          *ngIf="modalInfo.isSendButtonVisible()"
          type="button"
          mat-button
          style="color: #fff; background-color: #0f1642; border-color: #0f1642"
          (click)="onSend()">
          Enviar
        </button>
      </div>
    </div>
  </div>
</full-dialog>
